export default __webpack_public_path__ + "farmer-background.jpg";